import invariant from 'tiny-invariant';

import { useRestApiHeaders } from 'business/contextProviders/useApiHeaders';
import { useAppContext } from 'business/contextProviders/useAppContext';
import { useRingValidationV1ControllerGetDetail } from 'generated/apiComponents';
import { Module_Enum } from 'generated/graphql';

export const useGetRingValidationDetail = (ringId: string) => {
  const { currentConstructionSiteId } = useAppContext();
  invariant(currentConstructionSiteId, 'No construction site');

  const headers = useRestApiHeaders(Module_Enum.QualityControl);

  return useRingValidationV1ControllerGetDetail({
    pathParams: {
      constructionSiteId: currentConstructionSiteId,
      ringId,
    },
    headers,
  });
};
